<mat-spinner
  class="spinner-middle"
  *ngIf="!init"
  color="primary"
  diameter="24"
></mat-spinner>

<mat-dialog-content class="action-dialog">
  <div *ngIf="init">
    <!-- TITLE PART -->

    <h2>
      <ng-container *ngIf="inputProject.id">
        Project
        <span>#{{ inputProject.id }} ({{ getSubprojectStatus() }})</span>
      </ng-container>

      <ng-template newProject>Nieuw project</ng-template>
    </h2>

    <!--    OFFERTE PART-->

    <div class="form-title box">
      <checkbox
        [checked]="this.subProject.needsQuotation"
        (answer)="setQuotation($event)"
      ></checkbox>

      <div class="form-title-text checkbox-title">Offerte</div>
    </div>

    <div *ngIf="subProject.needsQuotation">
      <div class="d-flex justify-content-between">
        <div style="flex: 16">
          <div class="form-sub-title">Toegewezen aan</div>

          <mat-form-field appearance="outline" style="width: 100%">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              required
              [(ngModel)]="subProject.quotationHandler"
              name="quotationHandler"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of quotationHandlerChoices"
                [value]="option"
              >
                <span *ngIf="option.user">
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline offerte</div>

          <mat-form-field class="first-form-field" appearance="outline">
            <input
              matInput
              [matDatepicker]="quotationByDatePicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="subProject.quotationByDate"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="quotationByDatePicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #quotationByDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div align="right" style="flex: 1" class="left-space">
          <div class="form-sub-title">Belangrijk</div>

          <button
            [ngClass]="
              subProject.quotationImportant
                ? 'icon-button selected-icon-button'
                : 'icon-button non-selected-icon-button'
            "
            type="button"
            (click)="setImportantQuotation()"
            mat-button
            class="justify-items-center align-items-center"
          >
            <mat-icon>flag</mat-icon>
          </button>
        </div>
      </div>

      <div class="d-flex">
        <div style="flex: 2">
          <textarea-input
            [placeholder]="'Info omtrent offerte en opvolgen'"
            (answer)="setQuotationComments($event)"
            [initContent]="this.subProject.quotationComments"
            minHeight="60px"
            rows="10"
          >
          </textarea-input>
        </div>

        <div
          *ngIf="this.subProject.type === 'BaseProject'"
          style="flex: 1"
          class="left-space"
        >
          <yes-no
            [title]="'Weghalen inbegrepen'"
            [flexRow]="false"
            [value]="getAsBaseProject().includeRepoInPrice"
            [neverShowExtraInstructions]="true"
            (answer)="setIncludeRepoInPrice($event)"
          ></yes-no>
        </div>
      </div>

      <textarea-input
        [title]="'Opmerkingen facturatie'"
        (answer)="setExtraInfoInvoice($event)"
        [initContent]="this.subProject.extraInfoInvoice"
      >
      </textarea-input>

      <textarea-input
        *ngIf="this.subProject.quotation != null"
        [title]="'Mededeling voor klant'"
        (answer)="setNoteForCustomer($event)"
        [initContent]="this.subProject.quotation.noteForCustomer"
      >
      </textarea-input>

      <div *ngIf="subProject.needsQuotation">
        <mat-spinner
          class="spinner-middle"
          *ngIf="sending"
          color="primary"
          diameter="24"
        ></mat-spinner>

        <div class="d-flex">
          <button
            *ngIf="!sending"
            class="button"
            type="button"
            mat-button
            (click)="openSendQuotationModal()"
          >
            {{ getSendQuotationLabel() }}
          </button>

          <div
            *ngIf="subProject.quotationSent"
            class="d-flex click-link italics-text align-with-button quotation-send-reset-align"
            (click)="openResetQuotationSentModal()"
          >
            <mat-icon svgIcon="close" class="small-icon"></mat-icon>

            <p class="flexer click-link italics-text align-with-icon">reset</p>
          </div>
        </div>

        <div
          *ngIf="
            !subProject.quotationSent &&
            subProject.quotationSentResetReason != null &&
            subProject.quotationSentResetReason.length > 0
          "
        >
          <p class="preserve-line-break">
            <span class="strong">Reden nieuwe offerte: </span>
            {{ subProject.quotationSentResetReason }}
          </p>
        </div>

        <ng-container *ngIf="subProject.quotation.registeredActions != null">
          <registered-action-display
            *ngFor="
              let registeredAction of subProject.quotation.registeredActions
            "
            [inputRegisteredAction]="registeredAction"
          ></registered-action-display>
        </ng-container>

        <yes-no
          [title]="'Offerte opgevolgd'"
          [value]="subProject.quotationFollowed"
          [neverShowExtraInstructions]="true"
          (answer)="setQuotationFollowed($event)"
        ></yes-no>

        <div class="d-flex">
          <yes-no
            [showExtraInstructionsOn]="'Nee'"
            [value]="subProject.quotation.approved"
            [yesValue]="'Goedgekeurd'"
            [noValue]="'Afgekeurd'"
            [nullIsFalse]="false"
            [inputText]="subProject.quotation.approvalReasons"
            [extraInstructions]="'Geef hier de reden van afkeuring in'"
            [nullable]="true"
            (answer)="setQuotationApproved($event)"
            (answeredText)="setQuotationApprovalReasons($event)"
          ></yes-no>

          <div
            class="flexer quotation-approval-left font-italic"
            *ngIf="
              subProject.quotation.approved &&
              subProject.quotation.approvalRegistration
            "
          >
            - op
            {{ formatDate(subProject.quotation.approvalRegistration.date) }}
            door {{ subProject.quotation.approvalRegistration.by.firstName }}
            {{ subProject.quotation.approvalRegistration.by.lastName }}
          </div>
        </div>
      </div>
    </div>

    <!-- WERFBEZOEK PART  -->

    <div
      class="form-title box"
      [ngClass]="subProject.needsQuotation ? '' : 'upper-space'"
    >
      <checkbox
        [checked]="this.subProject?.projectPlacement?.siteVisit"
        (answer)="setSiteVisit($event)"
      ></checkbox>

      <div class="form-title-text checkbox-title">Werfbezoek</div>
    </div>

    <div *ngIf="subProject.projectPlacement?.siteVisit">
      <div class="d-flex justify-content-between">
        <div>
          <div class="form-sub-title">Toegewezen aan</div>

          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              required
              [(ngModel)]="subProject.projectPlacement.employee"
              name="siteVisitHandler"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of siteVisitEmployeeChoices"
                [value]="option"
              >
                <span *ngIf="option.user">
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline werfbezoek</div>

          <mat-form-field appearance="outline">
            <mat-label>Uiterste datum werfbezoek</mat-label>

            <input
              matInput
              [matDatepicker]="deadlineSiteVisitPicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="subProject.projectPlacement.deadlineSiteVisit"
              (ngModelChange)="deadlineSiteVisitChanged($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="deadlineSiteVisitPicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #deadlineSiteVisitPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div align="right" class="left-space">
          <div class="form-sub-title">Belangrijk</div>

          <button
            [ngClass]="
              subProject.siteVisitImportant
                ? 'icon-button selected-icon-button'
                : 'icon-button non-selected-icon-button'
            "
            type="button"
            (click)="setImportantSiteVisit()"
            mat-button
            class="justify-items-center align-items-center"
          >
            <mat-icon>flag</mat-icon>
          </button>
        </div>
      </div>

      <div class="d-flex">
        <div style="flex: 15">
          <textarea-input
            (answer)="setExtraInfoSiteVisit($event)"
            [initContent]="subProject.projectPlacement.extraInfoSiteVisit"
            [placeholder]="'Geef hier meer info over het werfbezoek'"
            minHeight="60px"
            rows="10"
          >
          </textarea-input>
        </div>

        <div style="flex: 1" class="left-space">
          <yes-no
            [yesValue]="'Ja'"
            [noValue]="'Nee'"
            [flexRow]="false"
            [title]="'Aanrekenen?'"
            (answer)="chargeChanged($event)"
            [value]="subProject.projectPlacement.charge"
            [showExtraInstructionsOn]="null"
          >
          </yes-no>
        </div>
      </div>

      <div *ngIf="locationAssets?.length > 0" class="flexer bottom-space">
        <div class="title">Foto(s) locatie</div>

        <div class="d-flex images">
          <div *ngFor="let item of locationAssets; trackBy: trackById">
            <div
              class="loadedImg align-middle"
              matTooltip="{{ item?.asset?.name }}"
            >
              <div class="d-flex image-box click-link max-summary-width">
                <a
                  download="{{ item.asset.name }}"
                  href="/api/assets/{{ item.asset.uuid }}"
                  style="margin-right: 7px"
                  class="d-flex box"
                >
                  <div class="filename">
                    {{ item?.asset?.name | shortenText : 8 }}
                  </div>

                  <a>
                    <mat-icon aria-hidden="false" aria-label="remove">
                      cloud_download
                    </mat-icon>
                  </a>
                </a>
              </div>

              <a
                class="click-link"
                href="/api/assets/{{ item.asset.uuid }}"
                *ngIf="isImage(item.asset)"
                data-lightbox="product"
              >
                <img
                  *ngIf="isImage(item.asset)"
                  class="max-asset-width max-asset-height"
                  src="/api/assets/{{ item.asset.uuid }}"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <mat-spinner
        class="spinner-middle"
        *ngIf="performingResetAction"
        color="primary"
        diameter="24"
      ></mat-spinner>

      <div *ngIf="!performingResetAction" class="d-flex bottom-space">
        <button
          type="button"
          (click)="resetQuotation()"
          mat-button
          class="button"
        >
          Nieuwe offerte
        </button>

        <button
          type="button"
          (click)="resetDesign()"
          mat-button
          class="button left-space"
        >
          Nieuw design
        </button>
      </div>

      <div class="d-flex">
        <yes-no
          *ngIf="subProject.projectPlacement.siteVisit"
          [title]="'Werfbezoek uitgevoerd'"
          [showExtraInstructionsOn]="null"
          [value]="subProject.projectPlacement.siteVisitExecuted"
          (answer)="siteVisitExecutedChanged($event)"
        ></yes-no>
      </div>

      <logged-action-display
        *ngIf="
          subProject.projectPlacement.siteVisitExecutedRegistration != null
        "
        [inputLoggedAction]="
          subProject.projectPlacement.siteVisitExecutedRegistration
        "
      ></logged-action-display>

      <div *ngIf="subProject.projectPlacement.siteVisitExecuted">
        <textarea-input
          (answer)="setSiteVisitFeedback($event)"
          [initContent]="subProject.projectPlacement.siteVisitFeedback"
          [placeholder]="'Geef hier feedback over het werfbezoek'"
          minHeight="60px"
          rows="10"
        >
        </textarea-input>

        <file-picker
          [hideUpload]="false"
          [title]="'Foto\'s werfbezoek uploaden'"
          [inputProjectPlacement]="subProject.projectPlacement"
          [formSection]="'siteVisitExecution'"
        ></file-picker>
      </div>
    </div>

    <!-- IN BEHANDELING PART-->

    <div
      class="form-title box"
      [ngClass]="subProject.projectPlacement?.siteVisit ? '' : 'upper-space'"
    >
      <checkbox
        [checked]="this.subProject.pending"
        (answer)="setPending($event)"
      ></checkbox>

      <div class="form-title-text checkbox-title">In behandeling</div>
    </div>

    <div *ngIf="subProject.pending">
      <div class="form-sub-title">Belangrijk</div>

      <button
        [ngClass]="
          this.subProject.pendingImportant
            ? 'icon-button selected-icon-button'
            : 'icon-button non-selected-icon-button'
        "
        type="button"
        (click)="setImportantPending()"
        mat-button
        class="justify-items-center align-items-center"
      >
        <mat-icon>flag</mat-icon>
      </button>
    </div>

    <!-- UITGESTELD-->

    <div class="form-title box upper-space">
      <checkbox
        [checked]="this.subProject.delayed"
        (answer)="setDelayed($event)"
      ></checkbox>

      <div class="form-title-text checkbox-title">Uitgesteld</div>
    </div>

    <div *ngIf="subProject.delayed">
      <textarea-input
        [title]="'Reden uitstelling'"
        (answer)="setDelayedReason($event)"
        [initContent]="subProject.delayedReason"
        [placeholder]="'Geef hier de reden waarom het project wordt uitgesteld'"
        minHeight="60px"
        rows="10"
      >
      </textarea-input>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="float-right">
  <button type="button" (click)="closeDialog()" class="btn btn-main btn-back">
    Annuleer
  </button>

  <button
    type="button"
    (click)="confirm()"
    mat-button
    class="button"
    id="btnSend"
  >
    Ok
  </button>
</mat-dialog-actions>
